import { PerformanceReviewProcessEditionWindowFragment } from 'generated/resources/graphql'

import { ScoreModeManager } from 'modules/performance_process/components/ScoreModeManager'
import { QuestionnairePreview } from 'modules/performance_process/components/questionnaire/QuestionnairePreview'
import { BasicInfo } from 'modules/performance_process/components/review/settings/BasicInfo'
import { Features } from 'modules/performance_process/components/review/settings/Features'
import { ReviewTypes } from 'modules/performance_process/components/review/settings/ReviewTypes'
import { TargetGroup } from 'modules/performance_process/components/review/settings/TargetGroup'
import { TargetManagement } from 'modules/performance_process/components/review/settings/TargetManagement'
import { Timeline } from 'modules/performance_process/components/review/settings/Timeline'
import { Visibility } from 'modules/performance_process/components/review/settings/Visibility'

interface Props {
  selected: string
  review: PerformanceReviewProcessEditionWindowFragment
  isConnectGoalsAndReviewsV2Enabled?: boolean
  hasCustomScoreConfigurationEnabled: boolean
  isJobCatalogTreeEnabled: boolean
  isEsignatureEnabled: boolean
}

export const ConfigurationComponent = ({
  selected,
  review,
  isConnectGoalsAndReviewsV2Enabled = false,
  hasCustomScoreConfigurationEnabled,
  isJobCatalogTreeEnabled,
  isEsignatureEnabled,
}: Props) => {
  switch (selected) {
    case 'basic':
      return (
        <BasicInfo
          review={review}
          isConnectGoalsAndReviewsV2Enabled={isConnectGoalsAndReviewsV2Enabled}
        />
      )
    case 'review_types':
      return <ReviewTypes review={review} />
    case 'target':
      return <TargetManagement review={review} />
    case 'visibility':
      return <Visibility review={review} />
    case 'timeline':
      return <Timeline review={review} />
    case 'target_group':
      return <TargetGroup review={review} />
    case 'questions_view':
      return (
        <QuestionnairePreview
          readonly
          reviewType={review.reviewerStrategies || []}
          questionnaires={review.questionnaires || undefined}
          isCompetenciesAssessmentsEnabled={review.competenciesAssessmentsConfiguration.enabled}
          scoreConfiguration={review.scoreConfiguration}
          hasCustomScoreConfigurationEnabled={hasCustomScoreConfigurationEnabled}
          scoreScale={review.scoreScale.scale}
          isJobCatalogTreeEnabled={isJobCatalogTreeEnabled}
        />
      )
    case 'features':
      return <Features review={review} isEsignatureEnabled={isEsignatureEnabled} />
    case 'scoring_system':
      return (
        <ScoreModeManager
          disabled={review.status !== 'draft'}
          mode={review.scoreConfiguration?.mode}
          questionnaireableId={review.id}
          questionnaireableType={'review_process'}
          hasCustomScoreConfigurationEnabled={hasCustomScoreConfigurationEnabled}
        />
      )

    default:
      return (
        <BasicInfo
          review={review}
          isConnectGoalsAndReviewsV2Enabled={isConnectGoalsAndReviewsV2Enabled}
        />
      )
  }
}
